import React from "react";
import { FestivalTableProps, FestivalTableState } from "./models";


import { Box, IconButton, Stack } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';

import MaterialReactTable from 'material-react-table';
import type { MRT_ColumnDef } from 'material-react-table';

import EditIcon from "@mui/icons-material/Edit";

import { t } from "@lingui/macro";

import { Festival } from "models";
import { ConfirmModal } from "commons/modal/confirm-modal";


export class FestivalTable extends React.Component<FestivalTableProps, FestivalTableState>
{
    private tableColumns: MRT_ColumnDef[];

    public constructor(props: any) {

        super(props)

        this.state={
            openConfirmModal: false,
            festivalToDelete: ""
        }


        this.tableColumns = [
            {
                header: t({
                    id: "ft-table-col-title",
                    message: "Nome Festival"
                }),
                accessorKey: "value",
                Cell: ({ cell }) => {
                    return (
                        <Box>
                            {cell.getValue<string>()}
                        </Box>
                    );
                },
            },
        ];
    }

    private openConfirmModal = (id: string) : void =>{
        this.setState(() => ({
            openConfirmModal: true,
            festivalToDelete: id
        }))
    }

    private cancelConfirmModalCallback = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
            festivalToDelete: ""
        }))
    }

    private acceptConfirmModal = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
        }))
        this.deleteFestival()
    }

    private deleteFestival = (): void => {
        this.props.deleteFestival(this.state.festivalToDelete);
        this.setState(() => ({
            festivalToDelete: ""
        }))

    }

    private getIdValue = (row: any): string => {
        return row.original.id
    }

    private openEditModal = (festival: any) => {
        this.props.openEditFestivalTable(festival as Festival);
    }

    private handlePageChange = (updateFn: any) => {
        let newPagination = updateFn(this.props.pagination);
        this.props.updatePaginationCallBackFn(newPagination);
    } 

    render() {
        return (
            <>
            <Box style={{ maxWidth: '100%' }}>
                <MaterialReactTable
                    columns={this.tableColumns}
                    rowCount={this.props.totalFestivalCount}
                    pageCount={Math.ceil(this.props.totalFestivalCount / this.props.pagination.pageSize)}
                    data={this.props.festivals}
                    enableRowSelection={false}
                    enableColumnOrdering={false}
                    enableColumnActions={false}
                    enableGlobalFilter={false}
                    enableFilters={false}
                    muiTableHeadCellProps={{
                        sx: {
                            color: "white",
                            backgroundColor: process.env.REACT_APP_PRIMARY_COLOR
                        }
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: ""
                        }
                    }}
                    enableRowActions
                    positionActionsColumn="last"
                    renderRowActions={({ row }) => (
                        <Stack direction={"row"} display={"flex"} justifyContent={"right"} >
                            <IconButton onClick={() => this.openEditModal(row.original)}>
                                <EditIcon />
                            </IconButton>
                            <IconButton onClick={() => this.openConfirmModal(this.getIdValue(row))}>
                                <DeleteIcon />
                            </IconButton>
                        </Stack>
                    )}
                    onPaginationChange={this.handlePageChange}
                    enableTopToolbar={false}
                    manualPagination={true}
                    autoResetPageIndex={false}
                    enableDensityToggle={false}
                    state={{
                        pagination: this.props.pagination
                    }} />
            </Box>
        {this.state.openConfirmModal && <ConfirmModal
            cancelConfirmCallback={this.cancelConfirmModalCallback}
            confirmCallback={this.acceptConfirmModal}
            text={"Sei sicuro di voler procedere con l'eliminazione del festival?"}
            textId={"ft-delete-festival-text"}
        />}
    </>)
    }
}
